import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';
import { PaginatorState } from './paginator-state.model';
import { PageEvent } from './page-event';
import { consts } from '@irian-ro/constants';

export function withPaginator() {
  const getFirstRecordIndexOfPageEvent = (event: PageEvent, rows: number) => {
    return event.pageIndex * rows;
  };

  return signalStoreFeature(
    withState<{ paginator: PaginatorState }>({ paginator: { first: 0, rows: consts.DEFAULT_TABLE_ROWS } }),

    withMethods((state) => {
      return {
        setPaginatorState: (paginator: PaginatorState) => {
          if (state.paginator().first !== paginator.first || state.paginator().rows !== paginator.rows) {
            patchState(state, {
              paginator: { ...paginator },
            });
          }
        },

        setMaterialPaginatorState: (event: PageEvent) => {
          const paginatorState: PaginatorState = {
            first: getFirstRecordIndexOfPageEvent(event, state.paginator().rows),
            rows: event.pageSize,
            page: event.pageIndex,
          };
          patchState(state, {
            paginator: { ...paginatorState },
          });
        },
      };
    })
  );
}
